import React from "react";
import Modal from "react-modal";

// Modal Styling (Optional)
const customStyles = {
  content: {
    width: "400px",
    height: "max-content",
    margin: "auto",
    textAlign: "center",
    borderRadius: "10px",
  },
};

const WinnerPopup = ({ isOpen, onClose, winnerDetails, onClaim }) => {
  // console.log("winnerDetailswinnerDetailswinnerDetails",winnerDetails)
  if (!winnerDetails || !winnerDetails.winning_data) return null;

  const totalWinningAmount = winnerDetails.winning_data.reduce(
    (total, item) => total + item.winning_amount,
    0
  );
  return (
    <Modal isOpen={isOpen} style={customStyles} ariaHideApp={false}>
      <h2>{winnerDetails.text}</h2>
      <div>
        {winnerDetails.winning_data.map((item, index) => (
          <div key={index} style={{ marginBottom: "10px" }}>
            <p><strong>Winning Number:</strong> {item.winning_number}</p>
            <p><strong>Winning Amount:</strong> ₹{item.winning_amount}</p>
          </div>
        ))}
        <hr />
        <h3><strong>Total Winning Amount:</strong> ₹{totalWinningAmount}</h3>
      </div>
      <button
        onClick={onClaim}
        style={{ padding: "10px", background: "green", color: "white", border: "none", borderRadius: "5px" }}
      >
        Claim Amount
      </button>
      {/* <button
        onClick={onClose}
        style={{ padding: "10px", background: "red", color: "white", border: "none", borderRadius: "5px", marginLeft:"10px" }}
      >
        Cancel
      </button> */}
    </Modal>
  );
};

export default WinnerPopup;
